import { ListMessages } from "@/graphql/queries.js";
import { API, graphqlOperation } from "aws-amplify";

export const GetAllMessages = {
  data() {
    return {
      GetAllViolationsList: [],
      overlay: false,
      user_type: "",
      MessagesList: [],
    };
  },
  methods: {
    async GetAllMessagesMethod() {
      try {
        console.log(
          " this.$store.getters.get_chat_id",
          this.$store.getters.get_chat_id
        );
        var inputParams = {
          chat_id:
            this.$store.getters.get_chat_id != undefined
              ? this.$store.getters.get_chat_id
              : null,
          message_sent_type: "NORMAL_MESSAGE",
          limit: "10000",
        };

        let result = await API.graphql(
          graphqlOperation(ListMessages, {
            input: inputParams,
          })
        );

        this.MessagesList = result.data.ListMessages.items;
        // this.scrollToBottom();
        this.overlay = false;
        // this.$store.commit("SET_CHAT_LIST", this.ChatsList);
      } catch (error) {
        this.overlay = false;
        console.log("Check error", error);
      }
    },
  },
};
